module.exports = __webpack_public_path__ + "e8b11f96dcba09a46e2cb8902dc953bb.MP3";